import React from "react";
export const ToggleItems = ({ data }) => {
  return (
    <>
      <ToggleItem
        title={`Key Highlights of the ${data?.singleTitle}`}
        data={data?.singleExcursionData?.excursion_ticket_highlights}
        id="excursion_ticket_highlights"
        index={0}
      />
      <ToggleItem
        title="Important Information"
        data={data?.singleExcursionData?.important_information}
        id="important_information"
      />
      <ToggleItem
        title="What's Included"
        data={data?.singleExcursionData?.whats_included}
        id="whats_included"
      />
      <ToggleItem
        title="Inclusions"
        data={data?.singleExcursionData?.excursion_ticket_inclusions}
        id="excursion_ticket_inclusions"
      />
      <ToggleItem
        title="Exclusions"
        data={data?.singleExcursionData?.excursion_ticket_exclusions}
        id="excursion_ticket_exclusions"
      />
      <ToggleItem
        title="About Cancellation policy"
        data={data?.singleExcursionData?.excursion_ticket_cancellation_policy}
        id="excursion_ticket_cancellation_policy"
      />
      <ToggleItem
        title="Your Journey"
        data={data?.singleExcursionData?.excursion_your_journey}
        id="excursion_your_journey"
      />
      <ToggleItem
        title="My tickets"
        data={data?.singleExcursionData?.exc_my_tickets}
        id="exc_my_tickets"
      />
      <ToggleItem
        title="Know Before You Go"
        data={
          data?.singleExcursionData?.excursion_ticket_tour_rules_and_regulation
        }
        id="excursion_ticket_tour_rules_and_regulation"
      />
    </>
  );
};

export const ToggleItem = ({ data, title, id }) => {
  if (!data) {
    return null;
  }
  return (
    <div className={`hw-excursion--toggleItem`} id={id}>
      <div
        className="hw-excursion--toggleTitle"
      >
        {title}
       
      </div>
     
        <div className={`hw-excursion--toggleContent hw-excursion--toggleContent${title}`}>
          <div
            dangerouslySetInnerHTML={{
              __html: data || "-",
            }}
          />
        </div>
      
    </div>
  );
};
